 
import {Stack, PrimaryButton} from "@fluentui/react";
import {ErrorCircle24Regular} from "@fluentui/react-icons";
import {ErrorMessage} from "@/components/SystemMessages";

import styles from "./Answer.module.css";

interface Props {
    error: string;
    onRetry: () => void;
}

export const AnswerError = ({error, onRetry}: Props) => {
    return (
        <Stack className={styles.answerContainer} verticalAlign="space-between">
            <ErrorCircle24Regular
                aria-hidden="true"
                aria-label="Error icon"
                primaryFill="red"
            />

            <Stack.Item grow>
                <p className={styles.answerText}>
                    {/* Show actual error message in local development, otherwise show default error message */}
                    <ErrorMessage
                        marginTop={0}
                        text={
                            process.env.NODE_ENV === "development"
                                ? error
                                : undefined
                        }
                    />
                </p>
            </Stack.Item>

            <PrimaryButton
                className={styles.retryButton}
                onClick={onRetry}
                text="Retry"
            />
        </Stack>
    );
};
